import { createBrowserHistory } from 'history';
export const browserHistory = createBrowserHistory();
//# sourceMappingURL=index.js.map